/**
 * Preselect tools for faceted search.
 */
H_Tools.preselect = (() => {
    // console.log('Preselect tools initialized');

    /**
     * Disables preselect for the faceted search form on the current page.
     */
    function disable() {
        if (!H_Tools.preselect.enabled) {
            return;
        }

        let form = document.querySelector('.js-faceted-search-form');

        if (!form) {
            return;
        }

        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'preselect');
        input.setAttribute('value', 'off');

        form.appendChild(input);

        H_Tools.preselect.enabled = false;
    }

    // Return an object to expose inner functions
    return {
        enabled: true,
        disable: disable,
    };
})();
